import {cx} from "@emotion/css";

import {ReactComponent as SvgPhone} from "~/assets/svg/phone.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmPhoneIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgPhone id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
